import { styled } from '@linaria/react'

export const ElPlaceholderImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-black);
  background-color: var(--color-white);
  border-radius: 0.25rem;
  flex-shrink: 0;
`

export const ElPlaceholderImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
  background-color: var(--color-white);
`
